import {Vnode} from "mithril";
import m from "mithril";

/**
 * Separator of datepicker boxes
 *
 * |-----|
 * |     |  <-- .box-top
 * |     |
 * |  .  |  <-- separator symbol .box-middle
 * |     |
 * |     |  <-- .box-bottom
 * |-----|
 */
export default class DateTimeSeparator {

    constructor(
        private readonly separator: string
    ) { }

    public view(): Vnode {
        return m('.separator', {}, [
            m('.box-top'),
            m('.box-middle',{}, this.separator),
            m('.box-bottom'),
        ]);

    }
}